// extracted by mini-css-extract-plugin
export var compactFilters = "_h9-4";
export var detailImage = "_h9-1";
export var dropdownContainer = "_h9-2";
export var imageContainer = "_h9-0";
export var selectedCard = "_h9-3";